import { render, staticRenderFns } from "./CommonHandleLogin.vue?vue&type=template&id=6a9ea3d8&"
import script from "./CommonHandleLogin.vue?vue&type=script&lang=ts&"
export * from "./CommonHandleLogin.vue?vue&type=script&lang=ts&"
import style0 from "./CommonHandleLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../sis/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports